import { useState } from 'react';
import { Eye, LogOut, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Persistent, unmissable banner shown whenever an admin is emulating a user (read-only). Fixed to the
 * top; a matching spacer is added so it never overlaps content. The ONLY visible difference between the
 * emulated view and the real user's view — everything below is byte-for-byte what the user sees.
 */
export function EmulationBanner() {
  const { user, isEmulating, exitEmulation } = useAuth();
  const [exiting, setExiting] = useState(false);
  if (!isEmulating || !user) return null;

  const who = user.name || user.franchisee?.name || user.yumId || 'user';
  const exit = async () => {
    setExiting(true);
    try {
      await exitEmulation();
    } catch {
      setExiting(false);
    }
  };

  return (
    <>
      <div className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 bg-spark px-4 py-2 text-sm text-white shadow-cool-md">
        <Eye className="h-4 w-4 shrink-0" />
        <span className="min-w-0 truncate">
          Viewing as <span className="font-semibold">{who}</span>
          {user.yumId && <span className="opacity-80"> ({user.yumId})</span>}
          <span className="ml-2 rounded-full bg-white/20 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide">Read-only</span>
        </span>
        <button
          type="button"
          onClick={exit}
          disabled={exiting}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-white/90 px-3 py-1 text-xs font-semibold text-spark-purple transition hover:bg-white disabled:opacity-70"
        >
          {exiting ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <LogOut className="h-3.5 w-3.5" />}
          Exit emulation
        </button>
      </div>
      {/* Spacer equal to the banner height so fixed positioning doesn't cover the app chrome. */}
      <div className="h-9" aria-hidden="true" />
    </>
  );
}
